<template>
  <div>

    <base-header class="pb-0 bg-light">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">eSIM Device Management</h6>
        </b-col>
        <b-col cols="5" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>

    <div class="p-5 bg-white">
      <b-container class="flex-cols">
        <h2>Blacklisted Devices</h2>
        <div class="table-responsive">
          <b-table
            head-row-variant="primary"

            id="blacklistTable"
            :items="blacklist_data"
            :fields="blacklist_fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            borderless
            show-empty
          >
            <template #cell(more)="row">
              <base-button size="xs" type="danger" v-on:click="deleteBlackisted(row.item.value_id)">
                <b-icon icon="x-circle"></b-icon>
                DELETE
              </base-button>
            </template>
            <template #empty="scope">
              <b>{{ scope.emptyText }}</b>
            </template>
            <template #emptyfiltered="scope">
              <h4>{{ scope.emptyFilteredText }}</h4>
            </template>
          </b-table>
          <br>
          <b-container class="text-xs">
            <b-row>
              <b-col class="text-left">{{ resultsFound }}</b-col>
              <b-col class="text-center">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="pageSize"
                  aria-controls="blacklistTable"
                  align="center"
                ></b-pagination>
              </b-col>
              <b-col class="text-right">{{ resultsUpdated }}</b-col>
            </b-row>
          </b-container>
        </div>
      </b-container>
    </div>

  <b-alert v-model="alertShow" :variant="alertVariant" dismissible class="mx-auto container-fluid">
    {{ alertMessage }}
  </b-alert>

  </div>
</template>


<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import eSimDashboardService from "@/common/api-services/esim-dashboard-service";
import commonService from "@/common/api-services/common";

export default {
  components: {
    RouteBreadCrumb,
  },

  data() {
    return {

      submitLoading: false,
      showResults: false,
      resultsFound: '',
      resultsUpdated: '',
      sortBy: 'Modified',
      sortDesc: true,
      pageSize: 1,
      currentPage: 1,
      totalRows: 1,
      totalPages: 1,

      //blacklist list
      blacklist_data: [],
      blacklist_fields: [
        {key: 'value_id', label: 'Id', sortable: true},
        {key: 'list-type', label: 'ListType', sortable: true},
        {key: 'target', label: 'List Name', sortable: true},
        {key: 'value', label: 'EID', sortable: true},
        {key: 'more', label: '', sortable: true},
      ],
      blacklist_title: [{key: 'title', label: 'Blacklisted Devices'}],
      blacklist: [],

      //setup for alert
      alertShow: false,
      alertVariant: 'success',
      alertMessage: '',
    }
  },

  mounted() {
    document.title = 'eSIM - Blacklist';
    this.getBlacklistData();
  },

  methods: {

    async getBlacklistData() {
      await eSimDashboardService.getBlacklistedList().then(res => {
        this.blacklist_data = res;

        this.totalRows = res.length;
        this.pageSize = 25;
        this.currentPage = 1;
        this.totalPages = Math.round(this.totalRows/25);
        if (this.totalPages<1) this.totalPages=1;
        this.resultsFound = '';//`Page ${res.pageInfo.number + 1} of ${res.pageInfo.size} of ${res.pageInfo.numberOfElements}`;//res.pageInfo.numberOfElements;
        this.resultsUpdated = '';//commonService.strToDate(Date.now(), 'DD MMM, YYYY HH:mm:ss');

      }).catch(err => {
        this.showToasterMsg( + err.message, true, 'danger');
      });
    },

    async deleteBlackisted(id) {
      await eSimDashboardService.delBlacklist(id).then(res => {
        if (!res) throw Error('Remove blacklisted device failed!');
        this.showToasterMsg('Remove blacklisted device succeeded.', true, 'success');
        commonService.refreshPage();
      }).catch(err => {
        this.showToasterMsg( err.message, true, 'danger');
      });
    },

    getStateClass(state) {
      let sstate = `${state}`;//convert to string
      sstate = sstate.toLowerCase();
      let sclass = '';
      if (sstate === 'released' || sstate === 'ok' || sstate === 'success' || sstate === 'available') {
        sclass = 'success';
      } else if (sstate === 'failed' || sstate === 'error' || sstate === 'cancel') {
        sclass = 'danger';
      } else if (sstate === 'info') {
        sclass = 'info';
      } else {
        sclass = 'warning';
      }
      //console.log('getStateClass[state][class]', sstate, sclass);
      return sclass;
    },

    showToasterMsg(message, append = false, variant = 'success') {
      //setup for alert
      this.alertVariant = variant;
      this.alertMessage = message;
      this.alertShow = true;
    },

  },
}
</script>
<style>
.table thead th {
  background-color: #5e72e4 !important;
  color: #ffffff !important;
  background-image: none !important;
  border-spacing: 0px !important;
  border-right: 1px solid #5e72e4 !important;
}

.table tbody td {
  background-color: #ffffff !important;
  color: #000000 !important;
  background-image: none !important;
  border-bottom: 1px solid #AAAAAA !important;
}
</style>
